module.exports = __webpack_public_path__ + "static/media/sleepyDragonFrame4.6a1098e7.png";